import { LoggerService as lgg } from "vue-components-library";

const LOG_TAG = "[GPSSOURCE HELPER]";

const configurationFilename = "twiageConfig.json";
const defaultConfiguration = {
  dataFormat: "TAIP",
  host: "0.0.0.0",
  port: 21000,
  portType: "udp4",
  source: "port",
};

export const gpsCoordsFromNmeaGprmcSentence = (sentence: string) => {
  const sentenceArray = sentence.substring(sentence.indexOf("$GPRMC")).split(",");
  const lat = parseFloat(sentenceArray[3]);
  const latDir = sentenceArray[4];
  const DD = Math.floor(lat / 100);
  const SS = lat - DD * 100;
  let latDec = DD + SS / 60;
  if (latDir === "S") {
    latDec = -latDec;
  }
  const lng = parseFloat(sentenceArray[5]);
  const lngDir = sentenceArray[6];
  const DD2 = Math.floor(lng / 100);
  const SS2 = lng - DD2 * 100;
  let lngDec = DD2 + SS2 / 60;
  if (lngDir === "W") {
    lngDec = -lngDec;
  }
  return {
    latitude: latDec,
    longitude: lngDec,
  };
};

export const gpsCoordsFromTaipFormat = (sentence: string) => {
  const latDD = sentence.substring(9, 12);
  const latMMM = sentence.substring(12, 17);
  const lngDD = sentence.substring(17, 21);
  const lngMMM = sentence.substring(21, 27);
  const latDec = parseFloat(latDD + "." + latMMM);
  const lngDec = parseFloat(lngDD + "." + lngMMM);
  return {
    latitude: latDec,
    longitude: lngDec,
  };
};

export const readConfig = () => {
  if (window.electron) {
    try {
      const configuration = window.electron.readConfigurationFile({
        configurationFilename,
        defaultConfiguration,
      });

      return configuration;
    } catch (error) {
      lgg.error(`${LOG_TAG} readConfig error:`, error);

      return defaultConfiguration;
    }
  }

  return defaultConfiguration;
};

export const writeConfig = (configuration) => {
  if (window.electron) {
    try {
      window.electron.writeConfigurationFile({
        configuration,
        configurationFilename,
        defaultConfiguration,
      });
    } catch (error) {
      lgg.error(`${LOG_TAG} writeConfig error:`, error);
    }
  }
};
